// export const TOKEN = "TOKEN";
export const USER_INFO = "USER_INFO";